export default () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.33333 5.33332V22.6667C5.33333 23.2413 5.5616 23.7924 5.96793 24.1987C6.37426 24.6051 6.92536 24.8333 7.5 24.8333H20.5C21.0746 24.8333 21.6257 24.6051 22.0321 24.1987C22.4384 23.7924 22.6667 23.2413 22.6667 22.6667V10.0372C22.6666 9.74852 22.6089 9.46279 22.4969 9.19676C22.3849 8.93073 22.2209 8.68975 22.0145 8.48799L17.2045 3.78416C16.7997 3.38837 16.2561 3.16673 15.69 3.16666H7.5C6.92536 3.16666 6.37426 3.39493 5.96793 3.80126C5.5616 4.20759 5.33333 4.75869 5.33333 5.33332Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.92408 19.25L10.8407 12.8333L14.3407 16.3333L18.7426 8.75"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
